import script from "./MakerCartPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartPage.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartPage.vue?vue&type=style&index=0&id=4b873a8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b873a8b"]])

export default __exports__